"use client"

import { FloatingLabel, Form, Card } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import{ showLoading } from "react-global-loading";

import * as myApi from "../../Api";
import { toast } from "react-toastify";
import { useEffect } from "react";

export default function ResendActivationForm() {

    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state?.data;

    useEffect(() => {
        // If no data passed, redirect to login
        if (data === undefined || !data?.email) {
            navigate(myApi.loginPath);
        }
    }, [data, navigate, myApi.loginPath]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        showLoading(true);
        const formData = new FormData(event.currentTarget);
        const email = formData.get("email");
        if (email === "") {
            toast("Email cannot be empty", { type: "error" });
        } else {
            try {
                const response = await myApi.post("/checkmail", { data_email: email });
                if (response.status === 200) {
                    await myApi
                        .post("/sendcode", { data_email: email, data_kode: "sendcode" })
                        .then((response) => {
                            toast("Email aktivasi telah dikirim", { type: "success" });
                            showLoading(false);
                            setTimeout(() => {
                                navigate("/auth/activation/", { state: { email: data.email, name: data.name } });
                            }, 1500);
                        })
                        .catch((error) => {
                            showLoading(false);
                            toast(error.message, { type: "error" });
                        });
                    showLoading(false);
                }
            } catch (error) {
                showLoading(false);
                toast(error.message, { type: "error" });
            }
        }

        showLoading(false);
    };

    return (
        <>
            <div className="auth-main-content m-auto m-1230 px-3">
                <Form onSubmit={handleSubmit}>
                    <Card className="bg-white border-0 rounded-10 mb-4 text-center">
                        <Card.Header className="bg-white border-0 text-center pt-4">
                            <button type="button" className="btn btn-sm" aria-label="Back to Login Page" onClick={() => window.location.href = myApi.loginPath}>&lt; Back to Login Page</button>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <img
                                src="/images/interface-welcome.png"
                                className="mb-3 mb-md-4 mx-auto"
                                alt="message"
                                width={124}
                                height={124}
                            />

                            <h4 className="fs-20 fw-semibold mb-2">Selamat Datang!</h4>

                            <p className="mb-4">
                                Sistem mendeteksi anda belum mengaktifkan akun.<br />
                                Silahkan lakukanaktivasi akun anda dengan melakukan verifikasi email dan mengikuti instruksi pada halaman selanjutnya.<br />
                            </p>

                            <div className="alert alert-info mb-4" role="alert">
                                <strong>Periksa folder Spam</strong>: Jika Anda tidak melihat email di inbox, harap periksa folder <strong>spam</strong> atau <strong>junk</strong> Anda. Email kami mungkin disaring oleh penyedia email Anda.
                            </div>

                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <FloatingLabel
                                    controlId="floatingEmail"
                                    label="Enter your email"
                                    className="mb-3"
                                >
                                    <Form.Control type="email" name="email" placeholder="Enter email" value={data?.email || ""} readOnly />
                                </FloatingLabel>
                            </Form.Group>
                            <button type="submit" className="btn btn-primary btn-large">Resend Activation Code</button>
                        </Card.Body>
                    </Card>
                </Form>
            </div>
        </>
    )
}